import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";

import { Container, Row, Col, Button, Form, Modal, Dropdown } from "react-bootstrap";
import Header from "../_Common/header";
import fleetDetails from "../../json/fleet-details.json";
import fleetInventory from "../../json/FullFleet/fleet-inventory.json";
import "./fleet-detail.scss";
import Aos from "aos";

// Placeholder images for gallery (using 1:1 placeholders)
const placeholderImages = [
    "https://placehold.co/600x600/14213d/FFF?text=Studio+Image+1",
    "https://placehold.co/600x600/14213d/FFF?text=Studio+Image+2",
    "https://placehold.co/600x600/14213d/FFF?text=Studio+Image+3",
    "https://placehold.co/600x600/14213d/FFF?text=Studio+Image+4",
    "https://placehold.co/600x600/14213d/FFF?text=Studio+Image+5",
    "https://placehold.co/600x600/14213d/FFF?text=Studio+Image+6",
];

export default function FleetDetail() {
    const { slug } = useParams();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [fleet, setFleet] = useState(null);
    const [price, setPrice] = useState(null);

    // Gallery Modal State
    const [showModal, setShowModal] = useState(false);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [galleryImages, setGalleryImages] = useState(placeholderImages);

    // Form State
    const [bookingDate, setBookingDate] = useState("");
    const [selectedTrip, setSelectedTrip] = useState("");
    const [guestCount, setGuestCount] = useState(1);

    // Touch/Swipe State
    const [touchStart, setTouchStart] = useState(null);
    const [touchEnd, setTouchEnd] = useState(null);

    // --- Floating WhatsApp Chat Logic ---
    const [showWaChat, setShowWaChat] = useState(false);
    const [waMessage, setWaMessage] = useState("");

    const toggleWaChat = () => {
        setShowWaChat(!showWaChat);
    };

    const handleWaChange = (e) => {
        const val = e.target.value;
        if (val.length <= 250) {
            setWaMessage(val);
        }
    };

    const handleWaSend = () => {
        if (!waMessage.trim()) return;
        const encoded = encodeURIComponent(waMessage);
        window.open(`https://wa.me/917666689265?text=${encoded}`, "_blank");
        setWaMessage(""); // Clear after send (optional)
        setShowWaChat(false);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        Aos.init({ duration: 800, once: true });

        // Find fleet by slug
        const foundFleet = fleetDetails.find((f) => f.slug === slug);
        if (foundFleet) {
            setFleet(foundFleet);
            if (foundFleet.trips && foundFleet.trips.length > 0) {
                setSelectedTrip(foundFleet.trips[0]);
            }
            setGuestCount(foundFleet.guests > 0 ? 1 : 1);

            // Set Fixed Internal Price
            setPrice(2000);

            // Set Gallery Images
            // Check inventory for gallery
            // Note: fleetDetails.json might not have gallery, but we updated fleet-inventory.json
            // We need to cross-reference or ensure where 'foundFleet' comes from.
            // The file imports BOTH fleet-details.json AND fleet-inventory.json.
            // fleet-details.json seems to be the main source for this page? 
            // Let's check where 'foundFleet' comes from. line 42 says: const foundFleet = fleetDetails.find((f) => f.slug === slug);

            // Wait, I updated fleet-inventory.json, but the component uses fleet-details.json?
            // checking imports:
            // import fleetDetails from "../../json/fleet-details.json";
            // import fleetInventory from "../../json/FullFleet/fleet-inventory.json";

            // I need to find the corresponding entry in fleetInventory to get the gallery images if they are not in fleetDetails.
            // Let's look up the boat in fleetInventory using the name or some ID.

            let inventoryBoat = null;
            Object.values(fleetInventory).forEach(category => {
                const found = category.find(b => b.name === foundFleet.name);
                if (found) inventoryBoat = found;
            });

            if (inventoryBoat && inventoryBoat.gallery && inventoryBoat.gallery.length > 0) {
                setGalleryImages(inventoryBoat.gallery.map(img => img.startsWith('http') ? img : `/${img}`));
            } else if (foundFleet.gallery && foundFleet.gallery.length > 0) {
                setGalleryImages(foundFleet.gallery.map(img => img.startsWith('http') ? img : `/${img}`));
            } else {
                setGalleryImages(placeholderImages);
            }

        } else {
            // Fallback or redirect if not found
            // navigate("/full-fleet");
        }
    }, [slug, navigate]);

    if (!fleet) {
        return <div className="loading-screen">Loading...</div>;
    }

    const handleEnquire = (e) => {
        e.preventDefault();
        const message = `Hi, I'd like to book:
Fleet Type: ${fleet.type}
Fleet Name: ${fleet.name}
Trip: ${selectedTrip}
Number of Guests: ${guestCount}
Date: ${bookingDate}`;

        const encodedMessage = encodeURIComponent(message);
        window.open(`https://wa.me/917666689265?text=${encodedMessage}`, "_blank");
    };

    const handleBookNow = () => {
        if (!price) return;
        const url = `https://pages.razorpay.com/yachtmumbai?amount=${price}&yacht_name=${encodeURIComponent(fleet.name)}&name=&email=&phone=`;
        window.open(url, "_blank");
    };

    const openGallery = (index) => {
        setCurrentImageIndex(index);
        setShowModal(true);
    };

    const nextImage = (e) => {
        if (e) e.stopPropagation();
        setCurrentImageIndex((prev) => (prev + 1) % galleryImages.length);
    };

    const prevImage = (e) => {
        if (e) e.stopPropagation();
        setCurrentImageIndex((prev) => (prev - 1 + galleryImages.length) % galleryImages.length);
    };

    // Touch/Swipe Logic
    const minSwipeDistance = 50;

    const onTouchStart = (e) => {
        setTouchEnd(null);
        setTouchStart(e.targetTouches[0].clientX);
    };

    const onTouchMove = (e) => {
        setTouchEnd(e.targetTouches[0].clientX);
    };

    const onTouchEnd = () => {
        if (!touchStart || !touchEnd) return;
        const distance = touchStart - touchEnd;
        const isLeftSwipe = distance > minSwipeDistance;
        const isRightSwipe = distance < -minSwipeDistance;

        if (isLeftSwipe) {
            nextImage();
        } else if (isRightSwipe) {
            prevImage();
        }
    };



    const categoryParam = searchParams.get("category");

    const handleBackToFleet = () => {
        if (categoryParam) {
            navigate(`/full-fleet?category=${categoryParam}`);
        } else {
            navigate("/full-fleet");
        }
    };

    // --- Floating WhatsApp Chat Logic ---


    return (
        <React.Fragment>
            <Header />
            <div className="fleet-detail-page">
                {/* Floating WhatsApp Button & Chat */}
                <div className={`whatsapp-widget ${showWaChat ? 'active' : ''}`}>
                    {showWaChat && (
                        <div className="whatsapp-chat-box">
                            <div className="wa-header">
                                <div className="d-flex align-items-center gap-2">
                                    <i className="ri-whatsapp-line"></i>
                                    <span>Chat with Us</span>
                                </div>
                                <button className="close-wa-btn" onClick={() => setShowWaChat(false)}>✕</button>
                            </div>
                            <div className="wa-body">
                                <textarea
                                    className="wa-textarea"
                                    placeholder="Type your message here..."
                                    value={waMessage}
                                    onChange={handleWaChange}
                                    rows="4"
                                ></textarea>
                                <div className="char-count text-end">
                                    {waMessage.length}/250
                                </div>
                            </div>
                            <div className="wa-footer">
                                <button className="wa-send-btn" onClick={handleWaSend}>
                                    Send Message <i className="ri-send-plane-fill"></i>
                                </button>
                            </div>
                        </div>
                    )}
                    <button className="floating-whatsapp-btn" onClick={toggleWaChat}>
                        {showWaChat ? <i className="ri-close-line"></i> : <i className="ri-whatsapp-line"></i>}
                    </button>
                </div>

                {/* HEADER SECTION */}
                <section className="detail-header-section">
                    <Container>
                        <div className="header-content">
                            <div className="title-block">
                                <div className="mb-3">
                                    <Button
                                        variant="outline-primary"
                                        className="back-btn"
                                        onClick={handleBackToFleet}
                                    >
                                        <i className="ri-arrow-left-line"></i> <span className="btn-text">Back to Fleet</span>
                                    </Button>
                                </div>
                                <span className="fleet-type">{fleet.type}</span>
                                <h1 className="fleet-name mb-3">{fleet.name}</h1>
                                {price && (
                                    <div className="d-flex align-items-center gap-3">
                                        {/* Price Hidden internally */}
                                    </div>
                                )}
                            </div>
                        </div>
                    </Container>
                </section>

                {/* ABOUT SECTION */}
                <section className="about-section">
                    <Container>
                        <h2 className="section-title">About Fleet</h2>
                        <div className="about-text">
                            {fleet.about}
                        </div>
                    </Container>
                </section>

                {/* THREE COLUMN INFO SECTION */}
                {/* MAIN CONTENT GRID */}
                <section className="main-content-section">
                    <Container>
                        <Row className="gy-4">
                            {/* LEFT COLUMN: INFO GRID */}
                            <Col lg={8}>
                                <div className="info-vertical-stack">
                                    <h3 className="section-subtitle mb-4">Fleet Features</h3>

                                    {/* ROW 1: TRIPS & CAPACITY */}
                                    <div className="info-row-top d-flex flex-wrap gap-4 mb-5">
                                        <div className="info-item trips-item flex-fill">
                                            <div className="icon-wrapper">
                                                <i className="ri-map-pin-line"></i>
                                            </div>
                                            <div className="content">
                                                <span className="label">Trips</span>
                                                <ul className="trips-list">
                                                    {fleet.trips.map((trip, index) => (
                                                        <li key={index}>{trip}</li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>

                                        <div className="info-item guests-item flex-fill">
                                            <div className="icon-wrapper">
                                                <i className="ri-group-line"></i>
                                            </div>
                                            <div className="content">
                                                <span className="label">Capacity</span>
                                                <div className="guest-number">
                                                    <span>{fleet.guests}</span> Guests
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* ROW 2: AMENITIES GRID */}
                                    <div className="info-row-bottom">
                                        <h4 className="amenities-label mb-3">Amenities</h4>
                                        <div className="amenities-grid">
                                            {fleet.points.map((point, index) => (
                                                <div className="amenity-item" key={index}>
                                                    <i className="ri-checkbox-circle-line"></i>
                                                    <span>{point}</span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </Col>

                            {/* RIGHT COLUMN: BOOKING FORM */}
                            <Col lg={4}>
                                <div className="booking-card" data-aos="fade-left">
                                    <h3 className="form-title">Book Your Trip</h3>
                                    <Form onSubmit={handleEnquire}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Select Date</Form.Label>
                                            <Form.Control
                                                type="date"
                                                required
                                                value={bookingDate}
                                                onChange={(e) => setBookingDate(e.target.value)}
                                            />
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                            <Form.Label>Trip</Form.Label>
                                            <Dropdown onSelect={(k) => setSelectedTrip(k)}>
                                                <Dropdown.Toggle variant="custom" className="w-100 text-start d-flex justify-content-between align-items-center" id="trip-dropdown">
                                                    {selectedTrip || "Select Trip"}
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu className="w-100">
                                                    {fleet.trips.map((trip, idx) => (
                                                        <Dropdown.Item key={idx} eventKey={trip}>{trip}</Dropdown.Item>
                                                    ))}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </Form.Group>

                                        <Form.Group className="mb-4">
                                            <Form.Label>Guests</Form.Label>
                                            <Form.Control
                                                type="number"
                                                min="1"
                                                max={fleet.guests}
                                                value={guestCount}
                                                onChange={(e) => setGuestCount(e.target.value)}
                                            />
                                        </Form.Group>

                                        <Button type="submit" className="w-100 enquire-btn">
                                            Enquire Now <i className="ri-whatsapp-line"></i>
                                        </Button>
                                    </Form>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>

                {/* GALLERY SECTION (Bento Grid) */}
                <section className="gallery-section">
                    <Container>
                        <h2 className="section-title mb-4">Gallery</h2>
                        <div className="bento-grid">
                            {galleryImages.map((img, index) => (
                                <div
                                    key={index}
                                    className={`bento-item item-${index}`}
                                    onClick={() => openGallery(index)}
                                    data-aos="zoom-in"
                                    data-aos-delay={index * 50}
                                >
                                    <img src={img} alt={`Gallery ${index}`} />
                                    <div className="overlay">
                                        <i className="ri-fullscreen-line"></i>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Container>
                </section>

                {/* GALLERY MODAL */}
                <Modal
                    show={showModal}
                    onHide={() => setShowModal(false)}
                    centered
                    size="lg"
                    className="gallery-modal"
                    contentClassName="bg-transparent border-0"
                >
                    <Modal.Body
                        className="p-0 position-relative"
                        onTouchStart={onTouchStart}
                        onTouchMove={onTouchMove}
                        onTouchEnd={onTouchEnd}
                    >
                        <Button className="close-modal-btn" onClick={() => setShowModal(false)}>✕</Button>
                        <Button className="nav-btn prev-btn" onClick={prevImage}>‹</Button>
                        <img src={galleryImages[currentImageIndex]} alt="Fullscreen" className="img-fluid w-100" />
                        <Button className="nav-btn next-btn" onClick={nextImage}>›</Button>
                    </Modal.Body>
                </Modal>

            </div>
        </React.Fragment>
    );
}
